// extracted by mini-css-extract-plugin
module.exports = {"fixedHeaderExtra":"fixedHeaderExtra--3OcXJ","staticHeader":"staticHeader--3lFCl"};